const VERSION: string = '0.1.7-prod.10'
export default VERSION;
